<script>
  import { Badge, Button, Card, Modal, Tooltip } from 'flowbite-svelte';
  import { EditOutline, InfoCircleOutline } from 'flowbite-svelte-icons';
  import { _ } from 'svelte-i18n';
  import CopyButton from './CopyButton.svelte';
  import EditLinkForm from './EditLinkForm.svelte';
  import Heading from './Heading.svelte';
  import Truncate from './Truncate.svelte';

  export let linkId = '';
  export let linkName = '';
  export let shortlink = '';
  export let destinationURL = '';
  export let imageUrl = '';
  export let tags = [];

  let modalOpen = false;

  const tagColors = [
    'dark',
    'red',
    'green',
    'yellow',
    'indigo',
    'purple',
    'pink',
  ];
  function getTagColor(tag) {
    return tagColors[tag.toLowerCase().charCodeAt(0) % tagColors.length];
  }
</script>

<Card size="xl">
  <Heading class="mb-4">
    <div class="flex items-center justify-between">
      <div class="inline-flex items-center gap-2">
        {$_('_shared.linkDetailsMeta.linkDetails', { default: 'Link Details' })}
        <img
          class="h-8 w-8 rounded border-[0.5px] border-gray-200 object-contain"
          src={imageUrl}
          alt={linkName}
        />
      </div>
      <div>
        <Button
          size="sm"
          on:click={() => {
            modalOpen = true;
          }}
          ><EditOutline class="me-2 h-3 w-3" />
          <span
            >{$_('LinkDetailsMeta.edit', {
              default: 'Edit',
            })}</span
          ></Button
        >
      </div>
    </div>
  </Heading>
  <div class="mb-2 flex flex-col lg:flex-row lg:items-center">
    <div class="mr-4 w-[150px] font-bold">
      {$_('_shared.linkDetailsMeta.linkName', {
        default: 'Link Name',
      })}
    </div>
    <div>
      <Truncate length={50} text={linkName} />
    </div>
  </div>
  <div class="mb-2 flex flex-col lg:flex-row lg:items-center">
    <div class="mr-4 w-[150px] font-bold">
      {$_('_shared.linkDetailsMeta.shortlink', {
        default: 'Shortlink',
      })}
    </div>
    <div>
      <a href={shortlink} target="_blank">{shortlink}</a>
      <CopyButton class="h-[24px] p-0 align-middle" {shortlink} />
    </div>
  </div>
  <div class="mb-2 flex flex-col lg:flex-row lg:items-center">
    <div class="mr-4 w-[150px] font-bold">
      {$_('_shared.linkDetailsMeta.destinationURL', {
        default: 'Destination URL',
      })}
    </div>
    <div>
      <Truncate showTooltip={false} length={100} text={destinationURL} />
    </div>
  </div>
  <div class="mb-2 mt-1 flex flex-col lg:flex-row lg:items-center">
    <div class="mr-4 flex w-[150px] items-center gap-1 font-bold">
      <span>
        {$_('_shared.linkDetailsMeta.labels', {
          default: 'Labels',
        })}
      </span>
      <InfoCircleOutline size="sm" />
      <Tooltip placement="top-end" class="max-w-[30ch] md:max-w-[60ch]">
        {$_('_shared.linkDetailsMeta.labels.tooltip', {
          default:
            'Add labels to your shortlinks to identify and categorize them. Labels make it easy to organize, search, and filter your links.',
        })}
      </Tooltip>
    </div>
    <div class="mt-1 flex flex-wrap gap-1 lg:mt-0">
      {#each tags as tag}
        <Badge rounded color={getTagColor(tag)}>{tag}</Badge>
      {/each}
    </div>
  </div>
</Card>
<Modal
  bind:open={modalOpen}
  title={$_('_shared.linkDetailsMeta.editShortlink', {
    default: 'Edit Shortlink',
  })}
>
  <EditLinkForm
    {linkId}
    {linkName}
    {tags}
    onCancel={() => {
      modalOpen = false;
    }}
    onSuccess={() => {
      modalOpen = false;
    }}
  />
</Modal>
